import moment from 'moment';
import React from 'react';
import {AiFillEdit} from 'react-icons/ai';
import {NavLink} from 'react-router-dom';
import CustomTable from './common/CustomTable/index';

const LatestJobTable = ({tableData}) => {
  const tHeadData = [
    {
      id: 1,
      keyIndex: 'country',
      label: 'Employer/Company Name',
      render: (_, {employerId}) =>
        `${employerId.firstName} ${employerId.lastName}`,
    },
    {
      id: 2,
      keyIndex: 'title',
      label: 'Job Title',
    },
    {
      id: 5,
      keyIndex: 'city',
      label: 'Company location',
      render: (_, {city, state, country}) =>
        [city, state, country].filter(Boolean).join(', '),
    },
    {
      id: 6,
      keyIndex: 'createdAt',
      label: 'Posting time',
      render: (item) => <>{moment(item).format('MM/DD/YYYY h:mm a')}</>,
    },
    {
      id: 7,
      keyIndex: '_id',
      label: 'Action',
      render: (_id) => (
        <NavLink aria-label="show candidat details" to={`/edit-job/${_id}`}>
          <AiFillEdit size={20} />
        </NavLink>
      ),
    },
  ];

  return (
    <div>
      <CustomTable tHeadData={tHeadData} tBodyData={tableData} />
    </div>
  );
};

export default LatestJobTable;
